import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'
import * as z from 'zod'
import {BasePayloadSchema} from './base-payload'
import {BreadcrumbSchema} from './breadcrumb'

/**
 * Payload schema for resource confirmation pages (e.g., after form submission).
 */
export const ResourceConfirmationPayloadSchema = z.lazy(() =>
  BasePayloadSchema.unwrap().extend({
    breadcrumbLinks: safeOptional(z.array(BreadcrumbSchema)),
  }),
)

export type ResourceConfirmationPayload = z.infer<typeof ResourceConfirmationPayloadSchema>

export function toResourceConfirmationPayload(payload: unknown): ResourceConfirmationPayload {
  return ResourceConfirmationPayloadSchema.parse(payload)
}
